import { capitalize } from '@/modules/stringUtils';
import { parseXMLSpriteSheets } from '../../parseClassicXMLSpritesheet';

export function parseSoundsData({
  gameData,
  gameAssetsFolder,
  commonAssetsFolder,
  activityConf,
  language,
}) {
  const gameConf = getCurrentLevelConf(gameData, activityConf);

  const gameSoundsData = gameConf.animations.reduce((acc, animation) => {
    const soundVolumeDef = gameConf.sounds?.find(
      (soundVolDef) => soundVolDef.id == animation.id
    );
    return {
      ...acc,
      [animation.id]: {
        id: animation.id,
        audio: `${gameAssetsFolder}/sounds/${animation.id}.mp3`,
        volume: soundVolumeDef ? soundVolumeDef.volume : 1,
      },
    };
  }, {});
  const feedbackSoundIds = [
    'intro',
    'perfecto',
    'bien',
    'bravo',
    'muybien',
    'oo',
    'oooo',
  ];
  const languageFolder = language == 'es' ? '' : `${language}/`;
  const feedbackSoundsData = feedbackSoundIds.reduce((acc, soundId) => {
    return {
      ...acc,
      [soundId]: {
        id: soundId,
        audio: `${commonAssetsFolder}/sounds/${languageFolder}${soundId}.mp3`,
        volume: 1,
      },
    };
  }, {});
  return { ...gameSoundsData, ...feedbackSoundsData };
}

export async function parseClassicXMLSpriteSheets(
  gameData,
  gameAssetsFolder,
  activityConf
) {
  const gameConf = getCurrentLevelConf(gameData, activityConf);
  let spriteSheetsConf;
  if (gameConf.spritesheet) {
    spriteSheetsConf = [gameConf.spritesheet];
  } else if (gameConf.animations.some((animation) => animation.spritesheet)) {
    spriteSheetsConf = gameConf.animations.map(
      (animation) => animation.spritesheet
    );
  } else {
    spriteSheetsConf = gameConf.animations.map((animation) => animation.id);
  }
  const spritesheetImgFormat = gameConf.spritesheetImgFormat ?? 'png';
  const uniqueSpriteSheetsConf = [...new Set(spriteSheetsConf)];

  const spriteSheetsAsArray = await Promise.all(
    uniqueSpriteSheetsConf.map((spritesheet) => {
      console.log(spritesheet);
      return parseXMLSpriteSheets(
        { spritesheet, spritesheetImgFormat },
        gameAssetsFolder
      );
    })
  );
  return spriteSheetsAsArray.reduce((acc, spriteSheet) => {
    return { ...acc, ...spriteSheet };
  }, {});
}

export function parseImagesData(gameData, gameAssetsFolder) {
  return {
    cover: {
      id: 'cover',
      src: `${gameAssetsFolder}/img/${gameData.gameConf.cover}`,
    },
    menuBg: {
      id: 'menuBg',
      src:
        process.env.NEXT_PUBLIC_CLOUDFRONT_STATIC_HOST +
        '/commonGameAssets/classic/menu_background.png',
    },
  };
}

export function parseActivityData(gameData, activityConf) {
  const gameConf = getCurrentLevelConf(gameData, activityConf);
  return {
    animations: gameConf.animations.map((animation) => ({
      ...animation,
      text: normalizeWord([...animation.words].pop()),
    })),
  };
}

function getCurrentLevelConf(gameData, activityConf) {
  const oldConf = gameData.gameConf.menu.buttons.find(
    (button) =>
      button.id.toLowerCase().includes('conceptrace') ||
      button.id.toLowerCase().includes('wordrace')
  );

  let currentLevelConf = null;
  if (oldConf.buttons) {
    currentLevelConf = oldConf.buttons.find(
      (button) =>
        button.buttonText.toLowerCase() == activityConf.level.toLowerCase()
    );
  } else {
    currentLevelConf = oldConf;
  }
  return currentLevelConf.minigameConf.activityData;
}

function normalizeWord(word) {
  return word.toLowerCase().trim();
}
